import React from "react"
import MenuIcon from "@mui/icons-material/Menu"
import Logo from "@web/asset/SVG/TomboLogo"
import styles from "./Layout.module.scss"
import { Drawer, IconButton, useMediaQuery } from "@mui/material"
import Navigation from "./Navigation"
import { useAuthState } from "@web/hooks/useAuthState"
import Link from "next/link"

type TomboHomepageLayoutProps = {
  children: React.ReactNode
}

const TomboHomepageLayout = ({ children }: TomboHomepageLayoutProps) => {
  const isMobile = useMediaQuery("(max-width:600px)")
  const [isDrawerOpen, setIsDrawerOpen] = React.useState(false)
  const { user, signOut } = useAuthState()

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <Logo />
        <div>
          {!user ? (
            <Link href="/login?callbackUrl=ai%2Fchat&autoLogin=true">
              <button className={styles.tomboButton}>Login</button>
            </Link>
          ) : (
            <button className={styles.tomboButton} onClick={signOut}>
              Sign Out
            </button>
          )}
        </div>
      </div>
      <div className={styles.content}>
        {isMobile ? (
          <>
            <div className={styles.navButtonContainer}>
              <IconButton onClick={() => setIsDrawerOpen(true)}>
                <MenuIcon />
              </IconButton>
            </div>
            <Drawer anchor="left" open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)}>
              <Navigation />
            </Drawer>
          </>
        ) : (
          <Navigation />
        )}
        <div className={styles.contentContainer}>{children}</div>
      </div>
    </div>
  )
}

export default TomboHomepageLayout
